<script>
  // your script goes here
   import { Router, Link, links, Route } from "svelte-routing";
  // import ButtonLoader from "../utils/button_loader.html";
  import { onMount, tick, createEventDispatcher } from "svelte";
  let reportTypeId = "";
  export let btnName ="Report";
  export let questionId;
  export let onHide;
  export let testId;
  export let userObj;
  let reportTypeArr =[]
  let qIssue ="";
  let isShow =false;
//  <p>{questionId}  questionIde printing </p>
        //  <p>{testId} testIdext of the printing </p>



    async function api_getReportTypeList() {

     var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            orgId : userObj.orgId
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch('/testAPI/fetchReportedQuestionsTypeList', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }

    
    }

    async function api_QuestionReport() {
      if(!qIssue){
        alert("Please Enter Issue");
        return;
      }
      if(!reportTypeId){
        alert("Please select issue type");
        return;
      }
     var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
           orgId : userObj.orgId,
           userId : userObj._id,
          "questionId": questionId,
          "testId": testId,
          "issue": qIssue,
          "reportTypeId": reportTypeId
      });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch('/testAPI/reportQuestionType', requestOptions);
            var response = await resObj.json();
             
             if (response.status === 200) {
               alert(response.msg);
             } else {
               alert(response.msg);
             }
        } catch (error) {
            alert("Something went wrong")
            console.error("error", error);
        }

    
    }

    function reportTy(params) {
      console.log("reportTypeId  :::",reportTypeId);
    }
onMount(async ()=>{
  /**
   * active: true
activeAccessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2MDRjOWFkOTA5NThlOTU2Y2FlMGU2NjUiLCJyb2xlIjoib3JnQWRtaW4iLCJuYW1lIjoiU2F2aXRyaWJhaSBQaHVsZSAiLCJlbWFpbCI6InNhdml0cmlAZ21haWwuY29tIiwibW9iaWxlTm8iOiI5MDQ5NTc0OTQ3Iiwib3JnSWQiOiI2MDRjOWFkOTA5NThlOTU2Y2FlMGU2NjQiLCJvcmdOYW1lIjoiUGh1bGUgaW5zdGl0dXRlICIsImlhdCI6MTYxNjA0OTU2OH0.iMlE6XgMWdYPuLJJm-nkQ7B1MXEmxgLu73zcmz23JOI"
createdBy: "604c9ad90958e956cae0e665"
createdOn: "2021-03-13T10:58:33.704Z"
deviceModel: "Google Chrome"
deviceName: "Browser"
dob: "2021-03-16T06:54:48.740Z"
email: "savitri@gmail.com"
gender: "O"
mobileNo: "9049574947"
name: "Savitribai Phule "
orgId: "604c9ad90958e956cae0e664"
reportsTo: "604c9ad90958e956cae0e665"
role: "orgAdmin"
userSeqId: 12292
_id: "604c9ad90958e956cae0e665"
  */
 /**[
    {
        "_id": "604f5e6093637916704b72cd",
        "seqId": 1042,
        "reportType": "Test report type",
        "orgId": "604c9ad90958e956cae0e664",
        "createdBy": "604c9ad90958e956cae0e665",
        "createdOn": "2021-03-15T13:17:20.282Z",
        "active": true,
        "updatedBy": "604c9ad90958e956cae0e665",
        "updatedOn": "2021-03-16T05:26:37.076Z"
    }
]*/
var response = await api_getReportTypeList();
if (response.status == 200) {
  reportTypeArr = response.reportTypes;
} else {
  reportTypeArr = [];
}

/* 
 * {
    "questionId": "604f06ebbebc3810c41b30a3",
    "testId": null,
    "issue": "THis is trsetsejkajs",
    "reportTypeId": "604f5e6093637916704b72cd"
}
*/

})
</script>
 <div id="" class="modalDialog">
      <div>

        <div class="modal-header" style="display: flex;justify-content: space-between;"><h2>Report Question</h2> <button class="bottom-btn close" on:click={onHide}>X</button></div>
        {#if reportTypeArr.length}
         <div class="modal-types">
           <!-- content here -->
        <div>
          <label>
            Report Type <span class="required">*</span>
          </label>
        </div>
        <div>
        {#each reportTypeArr as type}
           <!-- content here -->
          <label>
            <input type=radio bind:group={reportTypeId} value={type._id}>
            {type.reportType}
          </label>
        {/each}
         
        </div>
        </div>
        <div class="modal-issue" style="display: flex;flex-direction: column;">
         <label>
          Issue <span class="required">*</span>
        </label>
        
        <textarea bind:value={qIssue} name="" rows="4" cols="50"></textarea>
        </div>
        <div class="modal-header">
        <div></div>
          <div>
    
            <button class="submit" on:click={api_QuestionReport} >Report Question </button>
          </div>
        </div> 
        {:else}
           <!-- else content here -->
        {/if}
        
       </div>
   </div>
